import { IconFilterTheme } from "types/theme";

export interface IconProps {
  name: string;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  size?: number;
  color?: IconFilterTheme;
}
const Icon: React.FC<IconProps> = ({ name, className = '', onClick, style, size = 32, color = 'filter-base-ic-primary' }) => {
  const rel = name.replace(/^\/+/, '');
  const src = rel.startsWith('imgweb/') ? `/${rel}` : `/imgweb/${rel}`;
  
  return (
    <div
      className={`align-center flex justify-center ${className} b-icon ${color}`}
      onClick={onClick}
      style={{ ...style, width: `${size}px`, height: `${size}px` }}
    >
      <img className="" src={src} alt="" style={{ width: `${size * 0.75}px` }} />
    </div>
  );
};

export default Icon;
